@if (whiteboard.page_id) {
    <ul>
        <li>
            <div style="color: #4e5b72;"><small>Iconfarbe ändern</small></div>
            <div class="icon">
                <!-- //colors go here -->
                @for (color of colors; track color) {
                    <button (click)="changeColor(color)" [class.circle-color-active]="color == whiteboard.color"
                         [ngStyle]="{backgroundColor: color}" class="icons-vertical circle circle-color"></button>
                }
            </div>
        </li>
        <li>
            <div style="color: #4e5b72;"><small>Icon ändern</small></div>
            <div class="icon">
                @for (icon of icons; track icon) {
                    <button (click)="changeIcon(icon)" [class.circle-icon-active]="icon == whiteboard.icon"
                         class="icons-vertical circle circle-icon"><i [ngClass]="'fa ' + icon"></i></button>
                }
            </div>
        </li>
        <li>
            <button (click)="playVideo()" style="color: #47556c;">Aufzeichnung abspielen</button>
        </li>
        <li>
            <button (click)="moveToPage()" style="color: #47556c;">zur Verlinkung springen</button>
        </li>
        <li>
            <button (click)="removePage()" style="color: #cf6700;">Verlinkung entfernen</button>
        </li>
        <li>
            <button (click)="delete()" style="color: #cf0000;"><i class="fa fa-trash"></i> Whiteboard löschen</button>
        </li>
    </ul>
}
@if (!whiteboard.page_id) {
    <ul>
        <li>
            <button (click)="playVideo()" style="color: #47556c;">Aufzeichnung abspielen</button>
        </li>
        <li>
            <button (click)="addToPage()" style="color: #47556c;">Verlinken</button>
        </li>
        <li>
            <button (click)="delete()" style="color: #cf0000;"><i class="fa fa-trash"></i> Whiteboard löschen</button>
        </li>
    </ul>
}
